class ProductZoom {
  constructor() {
    const scriptElement = document.querySelector('script[data-section-id]');
    const sectionId = scriptElement ? scriptElement.getAttribute('data-section-id') : null;
    if (!sectionId) {
      return;
    }

    this.currentScale = 1;
    this.modal = document.querySelector(`#EnhancedProductModal-${sectionId}`);
    this.zoomImage = this.modal ? this.modal.querySelector('.product-zoom-image') : null;
    this.zoomInButton = this.modal ? this.modal.querySelector('.zoom-in') : null;
    this.zoomOutButton = this.modal ? this.modal.querySelector('.zoom-out') : null;
    this.closeButton = this.modal ? this.modal.querySelector('.product-media-modal__toggle') : null;

    if (this.modal && this.zoomImage && this.zoomInButton && this.zoomOutButton && this.closeButton) {
      this.zoomInButton.addEventListener('click', this.zoomIn.bind(this));
      this.zoomOutButton.addEventListener('click', this.zoomOut.bind(this));
      this.closeButton.addEventListener('click', this.closeModal.bind(this));
    } else {
      return;
    }

    this.setupProductGalleryEvents();
  }

  setupProductGalleryEvents() {
    const productImages = document.querySelectorAll('.product__media img');
    productImages.forEach(image => {
      image.addEventListener('click', this.imageClickHandler.bind(this));
      image.style.cursor = 'zoom-in';
    });
  }

  imageClickHandler(e) {
    e.preventDefault();
    e.stopPropagation();
    this.openModal(e.target);
  }

  openModal(image) {
    if (this.modal) {
      // Store the element that opened the modal, if needed later
      this.modal.openedBy = image;
      // Add the "open" class to display the modal
      this.modal.classList.add('open');
      this.zoomImage.src = image.src;
      this.currentScale = 1;
      this.zoomImage.style.transform = `scale(${this.currentScale})`;
    }
  }

  closeModal() {
    if (this.modal) {
      this.modal.classList.remove('open');
    }
  }

  zoomIn() {
    if (this.currentScale < 3) {
      this.currentScale += 0.2;
      this.zoomImage.style.transform = `scale(${this.currentScale})`;
    }
  }

  zoomOut() {
    if (this.currentScale > 1) {
      this.currentScale -= 0.2;
      this.zoomImage.style.transform = `scale(${this.currentScale})`;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.productZoom = new ProductZoom();
});
